import { agencyDashboardRoutes, agencyLaunchpadRoutes, subAccountRoutes } from '@/routes/constants/agency/'
import {
  DashboardRouteNames,
  FormBuilderRouteNames,
  QuizAppRouteNames,
  SurveyBuilderRouteNames,
  launchPadRouteNames,
} from '@/routes/constants/location'
import { RawLocation, Route, RouteConfig } from 'vue-router'
import { CustomerType, Location, User } from '../models'
import { inactiveAuthAgency, requireAuth, requireAuthAndScope } from './auth'
/*** Permissions ***/
import { locationLevelRoutesPermissions, routesRequiredPermissions } from '@/routes/permissions'

import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import LoginWithEmail from '@/pmd/pages/LoginWithEmail.vue'
import MediaFilesPage from '@/pmd/pages/medias/MediaFilesApp.vue'
import { FormServices } from '../services/FormServices'
import FunnelsServices from '../services/FunnelServices'
import { Modules } from '../util/modules'
// media files
import { userRoutesPermissionChecker } from '@/pmd/composition/userPermission'
import { checkAndRedirectToSummerOfAI, setJobberLeadSourceAndRedirect } from '@/util/helper'
import { executeCriticalPromises, executeDegradablePromises } from '@/util/interaction-tracker/promiseExecutor'
import firebase from 'firebase/compat/app'
import cloneDeep from 'lodash/cloneDeep'
import first from 'lodash/first'
import isEmpty from 'lodash/isEmpty'
import keys from 'lodash/keys'
import { setupLocale } from '../bootstrap'
import SurveysServices from '../services/SurveyServices'
import store from '../store'
import { onboardingRoutes } from './constants/onboarding'
import routeMapping from './pmd_v2_mapping'
const LaunchpadMicroApp = () => import('@/pmd/pages/LaunchpadMicroApp.vue')
// ====================================================== //
/*** Agency Level Components: ***/
const CustomReportSnapshotContainer = () =>
  import(/* webpackChunkName: "terms" */ '@/pmd/pages/reporting/reports/CustomReportSnapshotContainer.vue')

const SupportDashboard = () => import(/* webpackChunkName: "support" */ '@/pmd/pages/agency/SupportDashboard.vue')

const offersPage = () => import(/* webpackChunkName: "support" */ '@/pmd/pages/agency/offers/offersPage.vue')
const locationTransferPage = () => import(/* webpackChunkName: "support" */ '@/pmd/pages/agency/locationTransfer/locationTransfer.vue')

const LsaBusinessManager = () =>
  import(/* webpackChunkName: "lsa-manage-booking" */ '@/pmd/pages/LsaBusinessManager.vue').then(m => m.default)

const HelpDocuments = () => import(/* webpackChunkName: "help" */ '@/pmd/pages/agency/Help.vue').then(m => m.default)
const EjectLocation = () => import(/* webpackChunkName: "recources" */ '@/pmd/pages/eject/LocationEject.vue').then(m => m.default)

const AccountResources = () =>
  import(/* webpackChunkName: "recources" */ '@/pmd/pages/agency/AccountSalesResources.vue').then(m => m.default)

const CustomMenuLinkPage = () => import(/* webpackChunkName: "custom-menu-link" */ '@/pmd/pages/agency/CustomMenuLinkPage.vue')
const CustomPagesLinkPage = () => import(/* webpackChunkName: "custom-page-link" */ '@/pmd/pages/agency/CustomPagesLinkPage.vue')
const AgencyLaunchpad = () => import(/* webpackChunkName: "launchpad" */ '@/pmd/pages/agency/AgencyLaunchpad.vue')
const EmailBuilderMicroApp = () => import('@/pmd/pages/emailBuilder/EmailBuilderMicroApp.vue')
const ImportEmailTemplate = () => import('@/pmd/pages/emailBuilder/ImportEmailTemplate.vue')
// ========================================================== //
/*** Agency Level Settings Components: ***/
const ProfileSettingsV2 = () => import('@/pmd/pages/settings/Profile.vue').then(m => m.default)

const AuditLogs = () => import('@/pmd/pages/audit/AuditLogs.vue')

const AccountTeamsManagement = () =>
  import(/* webpackChunkName: "team-management" */ '@/pmd/pages/agency/AccountTeamsManagement.vue').then(m => m.default)

const Team = () => import('@/pmd/pages/agency/Team.vue').then(m => m.default)

const InactiveAgency = () =>
  import(/* webpackChunkName: "agency-billing-inactive" */ '@/pmd/pages/agency/billing/InactiveAgency.vue').then(m => m.default)
const InactiveLocation = () =>
  import(/* webpackChunkName: "agency-billing-inactive-location" */ '@/pmd/pages/agency/billing/InactiveLocation.vue').then(m => m.default)
const SandboxInactiveAgency = () =>
  import(/* webpackChunkName: "agency-billing-inactive" */ '@/pmd/pages/agency/billing/SandboxInactiveAgency.vue').then(m => m.default)

const SuspendedAgency = () =>
  import(/* webpackChunkName: "agency-billing-inactive" */ '@/pmd/pages/agency/billing/SuspendedAgency.vue').then(m => m.default)

// const AccountMailGunSettings = () =>
//   import(
//     /* webpackChunkName: "mailgun-settings" */ '@/pmd/pages/agency/AgencyMailGunSettings.vue'
//   ).then(m => m.default)

const AccountCustomFieldsSettings = () =>
  import(/* webpackChunkName: "custom-fields-settings" */ '@/pmd/pages/agency/AgencyCustomFieldsSettings.vue').then(m => m.default)

// ====================================================== //

// ========================================================== //
/*** Location Level Components: ***/
// const SideBar = () => import("@/pmd/components/locations/LocationSideBar.vue").then(m => m.default)
const LocationParent = () => import(/* webpackChunkName: "location" */ '@/pmd/pages/LocationParent.vue')
const EmptyLocationParent = () => import(/* webpackChunkName: "location-empty" */ '@/pmd/pages/EmptyLocationParent.vue')

const LocationDashboard = () =>
  import(/* webpackChunkName: "dashboard" */ '../pmd/pages/reporting/dashboard/LocationDashboard.vue').then(m => m.default)
const AppointmentsPage = () => import(/* webpackChunkName: "appointments" */ '../pmd/pages/AppointmentList.vue').then(m => m.default)
const AppointmentsReportPage = () =>
  import(/* webpackChunkName: "appointments-reports" */ '@/pmd/pages/reporting/appointment/AppointmentReportingDashboard.vue').then(
    m => m.default
  )
const NotificationsPage = () => import(/* webpackChunkName: "notifications" */ '../pmd/pages/NotificationsPage.vue').then(m => m.default)
const NotificationsList = () =>
  import(/* webpackChunkName: "notification-list" */ '../pmd/pages/NotificationsList.vue').then(m => m.default)

const RemindersPage = () => import(/* webpackChunkName: "reminders" */ '../pmd/pages/RemindersPage.vue').then(m => m.default)

const ForgotPassword = () => import(/* webpackChunkName: "forgot-password" */ '@/pmd/pages/ForgotPassword.vue').then(m => m.default)

const ChangePassword = () => import(/* webpackChunkName: "forgot-password" */ '@/pmd/pages/ChangePassword.vue').then(m => m.default)

const SetPassword = () => import(/* webpackChunkName: "forgot-password" */ '@/pmd/pages/SetPassword.vue').then(m => m.default)

const SignUp = () => import(/* webpackChunkName: "signup" */ '@/pmd/pages/SignUp.vue').then(m => m.default)
// const CalendarPage = () => import("@/pmd/pages/CalendarPage.vue").then(m => m.default)

// const ProfilePage = () => import("@/pmd/pages/ProfilePage.vue").then(m => m.default)
const AnalysisPage = () => import(/* webpackChunkName: "analysis-p" */ '@/pmd/pages/PageMoved.vue').then(m => m.default)

const CallReportingDashboard = () =>
  import(/* webpackChunkName: "numberpool-dashboard" */ '@/pmd/pages/reporting/calls/CallReportingDashboard.vue').then(m => m.default)
const AgentReporting = () => import(/* webpackChunkName: "agent-reporting" */ '@/pmd/pages/AgentReporting.vue').then(m => m.default)
// const AccountSearch = () => import("@/pmd/pages/agency/AccountSearch.vue").then(m => m.default)
const ManualActionList = () => import(/* webpackChunkName: "manual-actions" */ '@/pmd/pages/ManualActionList.vue').then(m => m.default)
const SmartList = () => import(/* webpackChunkName: "smartlist" */ '@/pmd/pages/smartlist/SmartList.vue').then(m => m.default)

const CustomerDetailNew = () => import(/* webpackChunkName: "customer-details" */ '@/pmd/pages/customers/RecordDetailsContainer.vue')
const OpportunitiesPage = () => import(/* webpackChunkName: "opportunities" */ '@/pmd/pages/OpportunitiesPage.vue')
const CustomerImportsPage = () => import(/* webpackChunkName: "customer-imports" */ '@/pmd/pages/customers/ContactBulkRequests.vue')

const CustomerRestore = () => import('@/pmd/pages/contact/RestorePage.vue')

const BulkActionsView = () => import(/* webpackChunkName: "customer-imports" */ '@/pmd/pages/smartlist/BulkActionsView.vue')
// ========================================================== //
/*** Location Level Settings Components: ***/
const SettingsPage = () => import(/* webpackChunkName: "location-settings" */ '@/pmd/pages/SettingsPage.vue')
const CustomValues = () =>
  import(/* webpackChunkName: "location-custom-values" */ '@/pmd/pages/settings/CustomValues.vue').then(m => m.default)
const CompanySettingsPage = () =>
  import(/* webpackChunkName: "location-company-settings" */ '@/pmd/pages/settings/CompanySettingsPage.vue').then(m => m.default)
const LocationBillingPage = () =>
  import(/* webpackChunkName: "location-company-settings" */ '@/pmd/pages/settings/LocationBillingPage.vue').then(m => m.default)
const LocationBillingSettings = () => import('@/pmd/pages/settings/LocationBillingSettings.vue').then(m => m.default)
const LocationWalletTransactions = () => import('@/pmd/pages/settings/LocationWalletTransactions.vue').then(m => m.default)
const IntegrationSettingsPage = () =>
  import(/* webpackChunkName: "location-integration-settings" */ '@/pmd/pages/settings/IntegrationSettingsPage.vue')
const PipelineSettings = () =>
  import(/* webpackChunkName: "location-pipeline-settings" */ '@/pmd/pages/settings/PipelineSettings.vue').then(m => m.default)

const AppointmentWidgetSettings = () =>
  import(/* webpackChunkName: "location-appointment-settings" */ '@/pmd/pages/settings/AppointmentWidgetSettings.vue')
const ChatWidgetSettings = () =>
  import(/* webpackChunkName: "location-chat-settings" */ '@/pmd/pages/settings/ChatWidgetSettings.vue').then(m => m.default)
const NoShowSMSSettings = () =>
  import(/* webpackChunkName: "location-nosms-settings" */ '@/pmd/pages/settings/NoShowSMSSettings.vue').then(m => m.default)
const BirthdaySMSSettings = () =>
  import(/* webpackChunkName: "location-birthday-sms-settings" */ '@/pmd/pages/settings/BirthdaySMSSettings.vue').then(m => m.default)
const AllPhoneNumbersSettings = () =>
  import(/* webpackChunkName: "location-phone-number-settings" */ '@/pmd/pages/settings/AllPhoneNumbersSettings.vue').then(m => m.default)
// const BulkEmailSettings = () =>
//   import('@/pmd/pages/settings/BulkEmailSettings.vue').then(m => m.default)
const LocationMailGunSettings = () =>
  import(/* webpackChunkName: "location-mailgun-settings" */ '@/pmd/pages/settings/LocationMailGunSettings.vue')
const TemplateSettings = () =>
  import(/* webpackChunkName: "location-template-settings" */ '@/pmd/pages/settings/TemplateMessageSettings.vue')

const LoginWithSSO = () => import(/* webpackChunkName: "login-sso" */ '@/pmd/pages/LoginWithSSO.vue').then(m => m.default)
const LoginWithToken = () => import(/* webpackChunkName: "login-token" */ '@/pmd/pages/LoginWithToken.vue').then(m => m.default)
const LoginForSupportAgent = () =>
  import(/* webpackChunkName: "login-support-agent" */ '@/pmd/pages/LoginForSupportAgent.vue').then(m => m.default)
const Logout = () => import(/* webpackChunkName: "logout" */ '@/pmd/pages/LogoutComp.vue').then(m => m.default)
const LoginWithShopify = () => import(/* webpackChunkName: "login-shopify" */ '@/pmd/pages/LoginWithShopify.vue').then(m => m.default)
const ShopifyLocationSelect = () =>
  import(/* webpackChunkName: "login-token" */ '@/pmd/pages/ShopifyLocationSelect.vue').then(m => m.default)
const CampaignList = () => import(/* webpackChunkName: "m-campaign-list" */ '@/pmd/pages/marketing/CampaignList.vue').then(m => m.default)
const CampaignNew = () => import(/* webpackChunkName: "m-campaign-new" */ '@/pmd/pages/marketing/CampaignNew.vue').then(m => m.default)
const CampaignDetail = () =>
  import(/* webpackChunkName: "m-campaign-detail" */ '@/pmd/pages/marketing/CampaignDetail.vue').then(m => m.default)
const CampaignActivity = () =>
  import(/* webpackChunkName: "m-campaign-activity" */ '@/pmd/pages/marketing/CampaignActivity.vue').then(m => m.default)
const CampaignAccountsList = () =>
  import(/* webpackChunkName: "m-campaign-acc-list" */ '@/pmd/pages/marketing/CampaignAccountsList.vue').then(m => m.default)
const BulkCampaignsPage = () =>
  import(/* webpackChunkName: "m-bulk-campaigns" */ '@/pmd/pages/marketing/BulkCampaignsPage.vue').then(m => m.default)
const FormBuilderPage = () =>
  import(/* webpackChunkName: "m-form-builder" */ '@/pmd/pages/marketing/FormBuilderPage.vue').then(m => m.default)
const Emails = () => import('@/pmd/pages/emailBuilder/EmailsComp.vue')

const TextBuilder = () => import(/* webpackChunkName: "m-text-builder" */ '@/pmd/pages/marketing/TextTemplates.vue').then(m => m.default)

const EmbedBuilder = () => import(/* webpackChunkName: "m-email-builder" */ '@/pmd/pages/marketing/EmbedBuilder.vue').then(m => m.default)
const FacebookAdFieldsMappingSettings = () =>
  import(/* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/settings/FacebookAdFieldsMappingSettings.vue')

const Analytics = () =>
  import(/* webpackChunkName: "domain-settings" */ '@/pmd/pages/analytics/FunnelWebsiteAnalytics.vue').then(m => m.default)

const DomainSettings = () =>
  import(/* webpackChunkName: "domain-settings" */ '@/pmd/pages/settings/DomainSettings.vue').then(m => m.default)

const RedirectSettings = () => import('@/pmd/pages/settings/RedirectSettings.vue').then(m => m.default)

const GhlLabs = () => import('@/pmd/pages/settings/GhlLabs/GhlLabs.vue').then(m => m.default)

const TagsSettings = () =>
  import(/* webpackChunkName: "tags-settings" */ '@/pmd/pages/settings/manage_tags/TagsSettings.vue').then(m => m.default)

const CustomEmailsSettings = () =>
  import(/* webpackChunkName: "tags-settings" */ '@/pmd/pages/settings/CustomEmailsSettings.vue').then(m => m.default)

const SMTPServiceSettings = () =>
  import(/* webpackChunkName: "smpt-settings" */ '@/pmd/pages/settings/SMTPServiceSettings.vue').then(m => m.default)

const EmbedSurvey = () => import(/* webpackChunkName: "m-embed-survey" */ '@/pmd/pages/marketing/EmbedSurvey.vue').then(m => m.default)

const SurveyList = () => import(/* webpackChunkName: "m-survey-list" */ '@/pmd/pages/marketing/SurveyList.vue').then(m => m.default)

const JotboxForm = () => import('@/pmd/pages/marketing/JotboxForm.vue').then(m => m.default)
const JotboxSurvey = () => import('@/pmd/pages/marketing/JotboxSurvey.vue').then(m => m.default)

const FunnelBuilderApp = () => import('@/pmd/pages/funnels/FunnelBuilderApp.vue')

const WordpressAppIndexPage = () => import(/* webpackChunkName: "wordpress-landing" */ '@/pmd/pages/wordpress/WordpressAppIndexPage.vue')

const FunnelDetailPage = () => import(/* webpackChunkName: "funnel-details" */ '@/pmd/pages/funnels/FunnelDetailPage.vue')

const MediaSettings = () => import(/* webpackChunkName: "media-center" */ '@/pmd/pages/medias/MediaFiles.vue')

const AcceptShareFunnel = () => import(/* webpackChunkName: "funnel-accept-share" */ '@/pmd/pages/funnels/AcceptShareFunnel.vue')

const AcceptShareTemplate = () =>
  import(/* webpackChunkName: "template-accept-share" */ '@/pmd/pages/template_library/AcceptShareTemplate.vue')

const AcceptShareMembershipProduct = () =>
  import(/* webpackChunkName: "membership-accept-share" */ '@/pmd/pages/membership/AcceptShareMembershipProduct.vue')

const TriggersPage = () => import(/* webpackChunkName: "triggers" */ '@/pmd/pages/triggers/TriggersPage.vue')
const TriggerDetailPage = () => import(/* webpackChunkName: "trigger-detail" */ '@/pmd/pages/triggers/TriggerDetailPage.vue')
const LinksPage = () => import(/* webpackChunkName: "m-links" */ '@/pmd/pages/marketing/LinksPage.vue')

const OnboardingImplementationCall = () => import(/* webpackChunkName: "test-app" */ '@/pmd/pages/onboarding/ImplementationCall.vue')

const OnboardingKickoffCall = () => import(/* webpackChunkName: "test-app" */ '@/pmd/pages/onboarding/KickoffCall.vue')

const OnboardingFlowV1 = () => import(/* webpackChunkName: "test-app" */ '@/pmd/pages/onboarding/OnboardingFlowV1.vue')

const LinkedInAdAccountsPage = () =>
  import(/* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/linkedIn/LinkedInAdAccountsPage.vue')

const GMBPages = () => import('@/pmd/pages/integrations/gmb/GMBPages.vue')
const FacebookPageSelectV2 = () =>
  import(/* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/facebook/FacebookPageSelectV2.vue')
const FacebookTroubleshoot = () =>
  import(/* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/facebook/FacebookTroubleshoot.vue')

const GoogleLocationSelect = () => import(/* webpackChunkName: "google-select" */ '@/pmd/pages/GoogleLocationSelect.vue')
const DrChronoOfficeSelect = () => import(/* webpackChunkName: "dr-chrono-office" */ '@/pmd/components/settings/DrChronoOfficeSelect.vue')

// const getPage = (pageName:string) => import(/* webpackChunkName: "p-[request]" */ `@/pmd/pages/${pageName}`);
// const getAgencyPage = (pageName:string) => import(/* webpackChunkName: "agency-[request]" */ `@/pmd/pages/agency/${pageName}`);

// import TeamSettingsPage from '@/pmd/pages/settings/TeamSettingsPage.vue';
const CalendarV2Page = () => import(/* webpackChunkName: "calendar-v2" */ '@/pmd/pages/CalendarV3Page.vue')

// ========================================================== //
const workflowBuilder = () => import('@/pmd/pages/workflow/WorkflowMicroApp.vue')

const membershipBuilder = () => import('@/pmd/pages/membership/MembershipMicroApp.vue')

// ========================================================== //
/*** Affiliates [Partner's Program] Components: ***/

const TikTokOauth = () => import(/* webpackChunkName: "dashboard" */ '../pmd/pages/integrations/TikTok.vue').then(m => m.default)

// ========================================================== //
// const FacebookKeywords = () =>
//   import('@/pmd/pages/reporting/facebook/ReportingFacebookKeywords.vue').then(m => m.default)
// const FacebookConversions = () =>
//   import('@/pmd/pages/reporting/facebook/ReportingFacebookConversions.vue').then(m => m.default)

const ElizaFAQSetting = () => import(/* webpackChunkName: "bot-faq" */ '@/pmd/pages/agency/ElizaFAQSetting.vue').then(m => m.default)

const GdprCompliance = () => import(/* webpackChunkName: "GDPRCompliance" */ '@/pmd/pages/agency/GdprCompliance.vue')

const FormBuilderApp = () => import(/* webpackChunkName: "FormBuilderApp" */ '@/pmd/pages/marketing/FormBuilderApp.vue') //src/pmd/pages/marketing/FormBuilderApp.vue
const surveyBuilderApp = () => import(/* webpackChunkName: "surveyBuilderApp" */ '@/pmd/pages/marketing/SurveyBuilderApp.vue') //src/pmd/pages/marketing/surveyBuilderApp.vue
const quizBuilderApp = () => import(/* webpackChunkName: "QuizBuilderApp" */ '@/pmd/pages/marketing/QuizBuilderApp.vue') //src/pmd/pages/marketing/QuizBuilderApp.vue

const LogViewer = () => import('@/pmd/pages/payments/LogViewer.vue')

const LogsPage = () => import('@/pmd/pages/payments/LogsPage.vue')

// ========================================================== //
/*** Location Level Launchpad ***/
const LaunchpadMobileAppLink = () =>
  import(/* webpackChunkName: "LaunchpadMobileAppLink" */ '@/pmd/components/launchpad/LaunchpadMobileAppLink.vue')
/*** Location Level User Update ***/
const LocationUserUpdateMicroApp = () => import(/* webpackChunkName: "LocationUserUpdate" */ '@/pmd/pages/LocationUserUpdateMicroApp.vue')

// ========================================================== //

/** Membership certificates builder  */
const certificatesBuilder = () => import('@/pmd/pages/certificates/CertificatesBuilder.vue')

const membershipBuilderV2 = () => import('@/pmd/pages/membership/MembershipBuilderV2.vue')

const AppReviewGuidelines = () => import('@/pmd/pages/developer_marketplace/AppReviewRatingGuidelines.vue')

/*** Agency Setting Components: ***/

// const AgencyDashboardRoot = () =>
// import(
//   /* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/agencyDashboard/AgencyDashboardRoot.vue'
// ).then(m => m.default)

// const AgencyDashboardMain = () =>
//   import(
//      /* webpackChunkName: "agency-dashboard" */ '@/pmd/pages/agencyDashboard/AgencyDashboardV2.vue'
//   ).then(m => m.default)

const CountdownTimerBuilder = () =>
  import(/* webpackChunkName: "countdown-timer" */ '@/pmd/pages/countdown_timer/CountdownTimerBuilder.vue')

const { checkFormsPermissions, checkQuizzesPermissions, checkSurveysPermissions } = userRoutesPermissionChecker()
// access firebase perf service
const _requireAccessLevelAndLocation = (to: Route, from: Route, next: (to?: RawLocation) => void) => {
  store
    .dispatch('auth/get')
    .then(async () => {
      const currentUser = await store.dispatch('user/get')
      const user = new User(cloneDeep(currentUser))
      if (user.type === User.TYPE_ACCOUNT && user.role === User.ROLE_USER) {
        const locationId = first(keys(user.locations || {}).sort()) || ''
        return next({
          name: 'dashboard',
          replace: true,
          params: { location_id: locationId },
        })
      } else {
        next()
      }
    })
    .catch(() => {
      next({
        name: 'login',
        query: { url: encodeURIComponent(to.fullPath) },
        replace: true,
      })
    })
}

let firstLoad = true

export const requireAuthAndLocation = (to: Route, from: Route, next: (to?: RawLocation) => void) => {
  store
    .dispatch('auth/get')
    .then(async () => {
      const company = await store.dispatch('company/get')
      const currentUser = await store.dispatch('user/get')
      const user = new User(cloneDeep(currentUser))
      const saasPermissions = new Location(await store.state.locations.currentLocation)
      const getSidebarVersion = store.getters['sidebarv2/getVersion']
      if (getSidebarVersion == 'v2' && to.name && routeMapping[to.name]) {
        return next({
          name: routeMapping[to.name],
          params: to.params,
          query: to.query,
          replace: true,
        })
      }
      const permissions = user.permissions
      await inactiveAuthAgency(to, from, next)

      const requiredPermission = routesRequiredPermissions[to.name]
      if (permissions[requiredPermission] === false) {
        if (from.path) {
          return next({
            path: from.path,
            replace: true,
          })
        } else {
          return next({
            path: '/',
            replace: true,
          })
        }
      }

      if (
        company &&
        company.onboardingInfo.pending === true &&
        company.status !== 'active_test-agency' &&
        user &&
        user.type === 'agency' &&
        to.name !== 'onboarding-trial-call'
      ) {
        return next({
          name: onboardingRoutes.onboardingFlow.version_a,
          replace: true,
        })
      }

      if (!to.params.location_id) {
        if (company.customerType === CustomerType.AGENCY && user.type === User.TYPE_AGENCY) {
          try {
            if (user.role === User.ROLE_ADMIN) {
              const redirectedToSummerOfAIMenu = await checkAndRedirectToSummerOfAI({
                store,
                router: null,
                locationId: null,
                next,
              })
              if (redirectedToSummerOfAIMenu) return
            }
          } catch (err) {
            console.error('redirect to summer of ai failed: ', err)
          }
          if (
            company.saasSettings && company.saasSettings.agency_dashboard_visible_to === 'individual'
              ? user.isAgencyOwner
              : user.role === User.ROLE_ADMIN
          ) {
            const redirectToAgencyLaunchpad = await store.dispatch('launchpad/redirectToAgencyLaunchpad')
            if (redirectToAgencyLaunchpad) {
              return next({ name: agencyLaunchpadRoutes.default, replace: true })
            } else {
              return next({ name: agencyDashboardRoutes.main, replace: true })
            }
          } else {
            return next({ name: subAccountRoutes.accounts.default, replace: true })
          }
        } else if (!isEmpty(user.locations)) {
          // This is an location level user who only has access to certain locations.
          const locationId = first(keys(user.locations || {}).sort()) || ''
          const allowRedirection = await store.dispatch('launchpad/redirectToLaunchpad', locationId)
          if (allowRedirection) {
            return next({
              name: launchPadRouteNames.oldLaunchpad,
              replace: true,
              params: { location_id: locationId },
            })
          } else {
            return next({
              name: DashboardRouteNames.oldDashboard,
              replace: true,
              params: { location_id: locationId },
            })
          }
        } else {
          // Direct accounts will come into this case.
          const locations = await Location.fetchAllLocations()
          if (locations.length > 0) {
            const firstLocationId = locations[0].id
            const allowRedirection = await store.dispatch('launchpad/redirectToLaunchpad', firstLocationId)
            if (allowRedirection) {
              return next({
                name: launchPadRouteNames.oldLaunchpad,
                replace: true,
                params: { location_id: locations[0].id },
              })
            } else {
              return next({
                name: DashboardRouteNames.oldDashboard,
                replace: true,
                params: { location_id: locations[0].id },
              })
            }
          }
        }
        return
      } else {
        if (user.type === User.TYPE_ACCOUNT) {
          const availableLocations = keys(user.locations) || []
          if (availableLocations.indexOf(to.params.location_id) === -1) {
            return next({
              path: '/',
              replace: true,
            })
          }
        }
        const location = await store.dispatch('locations/getById', to.params.location_id)
        if (firstLoad) {
          firstLoad = false
          // const assignedTo = user.isAssignedTo ? user.id : ''
          // console.log(`Assigned to user => ${assignedTo}`)
          await store.dispatch('auth/refreshFirebaseToken', { locationId: to.params.location_id || null, refresh: true }, { root: true })

          // ============================================================
          // CRITICAL BLOCKING OPERATIONS
          // User waits for these - app won't function without them
          // ============================================================
          const criticalBlockingOperations = executeCriticalPromises(
            [
              {
                name: 'locations/resetCurrentLocation',
                promise: store.dispatch('locations/resetCurrentLocation', {
                  locationId: to.params.location_id,
                }),
              },
              {
                name: 'users/syncAll',
                promise: store.dispatch('users/syncAll', to.params.location_id),
              },
              // Keep feature flags blocking so route mapping / UI flags are ready.
              {
                name: 'featureFlags/syncAll',
                promise: store.dispatch('featureFlags/syncAll', to.params.location_id),
              },
            ],
            { context: 'PMDRoutes.requireAuthAndLocation.critical' }
          )

          // ============================================================
          // DEGRADABLE NON-BLOCKING OPERATIONS
          // 5s timeout - failures logged but don't break the app
          // ============================================================
          executeDegradablePromises(
            [
              {
                name: 'stripeConnect/syncAll',
                promise: store.dispatch('stripeConnect/syncAll', to.params.location_id),
              },
              {
                name: 'membership/syncAll',
                promise: store.dispatch('membership/syncAll', { locationId: to.params.location_id }),
              },
              { name: 'wordpress/syncAll', promise: store.dispatch('wordpress/syncAll', to.params.location_id) },
              {
                name: 'wordpress/fetchOfferingEnabled',
                promise: store.dispatch('wordpress/fetchOfferingEnabled', to.params.location_id),
              },
            ],
            { context: 'PMDRoutes.requireAuthAndLocation' }
          )

          await criticalBlockingOperations
          // await Promise.allSettled([

          //   // store.dispatch('pipelines/syncAll', to.params.location_id),
          //   // store.dispatch('campaigns/syncAll', to.params.location_id),
          //   // store.dispatch('workflows/syncAll', to.params.location_id),
          //   // store.dispatch('contacts/syncAll', to.params.location_id),
          //   // store.dispatch('contacts/syncAll', to.params.location_id),
          //   // store.dispatch('conversation/syncAll', {
          //   //   locationId: to.params.location_id,
          //   //   assignedTo,
          //   // }),
          //   // store.dispatch('teams/syncAll', to.params.location_id),
          //   // store.dispatch('smtpServices/syncAll', to.params.location_id),
          //   // store.dispatch('mailgunServices/syncAll', to.params.location_id),

          // ])
          store.dispatch('filters/syncAll', to.params.location_id)

          const sideBarRoute = ['contact_detail']
          if (sideBarRoute.includes(to.name)) {
            store.commit('setSideBarState', true)
          }
        }
        const locationLevelPermissionKey = locationLevelRoutesPermissions[to.name]
          ? locationLevelRoutesPermissions[to.name]
          : requiredPermission

        let locationHasPermission = true

        if (location.permissions && !isEmpty(location.permissions)) {
          if (Array.isArray(locationLevelPermissionKey)) {
            const keyPermissions = locationLevelPermissionKey.filter(key => location.permissions[key] !== false)
            // location has permission for any of the key in the list for route
            locationHasPermission = keyPermissions.length > 0
          } else {
            locationHasPermission = location.permissions[locationLevelPermissionKey] !== false
          }
        }

        // const hasUserPermission = user.locationPermissions[location.id]
        //   ? user.locationPermissions[location.id][requiredPermission] !== false
        //   : true

        if (
          !location ||
          location.company_id !== company.id ||
          location.deleted ||
          !locationHasPermission
          // hasUserPermission === false
        ) {
          if (location.permissions && !location.permissions[locationLevelRoutesPermissions.dashboard]) {
            if (to.name === 'dashboard') {
              return next({
                name: 'conversations',
                params: to.params,
                replace: true,
              })
            } else {
              return next({
                path: from.path,
                replace: true,
              })
            }
          } else {
            // return next({
            //   path: '/',
            //   replace: true,
            // })
            return next({
              name: 'dashboard',
              replace: true,
              params: { location_id: to.params.location_id },
            })
          }
        } else if (user.isPasswordPending && user.role == User.ROLE_USER && to.name !== 'location_user_update') {
          return next({
            name: 'location_user_update',
            replace: true,
            params: { location_id: to.params.location_id },
          })
        }
      }

      if (to.name === 'audit-location' && user.role !== 'admin') {
        return next({
          name: 'dashboard',
          replace: true,
          params: { location_id: to.params.location_id },
        })
      }

      if (
        [
          FormBuilderRouteNames.default,
          FormBuilderRouteNames.main,
          'form-builder-manage-v2',
          QuizAppRouteNames.default,
          QuizAppRouteNames.main,
        ].includes(to.name as string)
      ) {
        try {
          if (!to.params.builder_id) next()
          if (!checkFormsPermissions(saasPermissions.permissions, store.getters['user/getScopes'])) {
            return next({ name: DashboardRouteNames.default, replace: true })
          }
          const locationId = to.params.location_id
          const { data } = await FormServices.getById({ id: to.params.builder_id })
          const { form } = data
          if (!form || form.locationId !== locationId) {
            return next({ name: agencyDashboardRoutes.default, replace: true })
          } else {
            return next()
          }
        } catch (error) {
          console.error(error)
          return next({ name: agencyDashboardRoutes.default, replace: true })
        }
      }

      if ([QuizAppRouteNames.default, QuizAppRouteNames.main].includes(to.name as string)) {
        try {
          if (!to.params.builder_id) next()
          if (!checkQuizzesPermissions(saasPermissions.permissions, store.getters['user/getScopes'])) {
            return next({ name: DashboardRouteNames.default, replace: true })
          }
          const locationId = to.params.location_id
          const { data } = await FormServices.getById({ id: to.params.builder_id })
          const { form } = data
          if (!form || form.locationId !== locationId) {
            const redirectToAgencyLaunchpad = await store.dispatch('launchpad/redirectToAgencyLaunchpad')
            if (redirectToAgencyLaunchpad) {
              return next({ name: agencyLaunchpadRoutes.default, replace: true })
            } else {
              return next({ name: agencyDashboardRoutes.main, replace: true })
            }
          } else {
            return next()
          }
        } catch (error) {
          console.error(error)
          const redirectToAgencyLaunchpad = await store.dispatch('launchpad/redirectToAgencyLaunchpad')
          if (redirectToAgencyLaunchpad) {
            return next({ name: agencyLaunchpadRoutes.default, replace: true })
          } else {
            return next({ name: agencyDashboardRoutes.main, replace: true })
          }
        }
      }

      if ([SurveyBuilderRouteNames.default, SurveyBuilderRouteNames.main, 'survey-builder-manage-v2'].includes(to.name as string)) {
        try {
          if (!to.params.builder_id) next()
          const locationId = to.params.location_id
          if (!checkSurveysPermissions(saasPermissions.permissions, store.getters['user/getScopes'])) {
            return next({ name: DashboardRouteNames.default, replace: true })
          }
          const { data } = await SurveysServices.getById(to.params.builder_id)
          const { survey } = data
          if (!survey || survey.locationId !== locationId) {
            const redirectToAgencyLaunchpad = await store.dispatch('launchpad/redirectToAgencyLaunchpad')
            if (redirectToAgencyLaunchpad) {
              return next({ name: agencyLaunchpadRoutes.default, replace: true })
            } else {
              return next({ name: agencyDashboardRoutes.main, replace: true })
            }
          } else {
            return next()
          }
        } catch (error) {
          console.error(error)
          const redirectToAgencyLaunchpad = await store.dispatch('launchpad/redirectToAgencyLaunchpad')
          if (redirectToAgencyLaunchpad) {
            return next({ name: agencyLaunchpadRoutes.default, replace: true })
          } else {
            return next({ name: agencyDashboardRoutes.main, replace: true })
          }
        }
      }

      if (['page-builder-edit', 'page-builder-edit_versions'].includes(to.name as string)) {
        try {
          if (!to.params.page_id) next()
          const locationId = to.params.location_id
          const { data } = await FunnelsServices.getPageById(to.params.page_id)

          if (!data || data.locationId !== locationId) {
            const redirectToAgencyLaunchpad = await store.dispatch('launchpad/redirectToAgencyLaunchpad')
            if (redirectToAgencyLaunchpad) {
              return next({ name: agencyLaunchpadRoutes.default, replace: true })
            } else {
              return next({ name: agencyDashboardRoutes.main, replace: true })
            }
          } else {
            return next()
          }
          return next()
        } catch (error) {
          console.error(error)
          const redirectToAgencyLaunchpad = await store.dispatch('launchpad/redirectToAgencyLaunchpad')
          if (redirectToAgencyLaunchpad) {
            return next({ name: agencyLaunchpadRoutes.default, replace: true })
          } else {
            return next({ name: agencyDashboardRoutes.main, replace: true })
          }
        }
      }

      await setupLocale(to, from)
      next()
    })
    .catch(() => {
      next({
        name: 'login',
        query: { url: encodeURIComponent(to.fullPath) },
        replace: true,
      })
    })
}

const requireShareAcceptAccess = (to: Route, from: Route, next: (to?: RawLocation) => void) => {
  store
    .dispatch('auth/get')
    .then(async () => {
      const currentUser = await store.dispatch('user/get')
      const user = new User(cloneDeep(currentUser))
      const userHasAccess = user.type === User.TYPE_AGENCY || user.role === User.ROLE_ADMIN

      if (!userHasAccess) {
        next({ name: 'dashboard', replace: true })
      } else {
        next()
      }
    })
    .catch(() => {
      next({
        name: 'login',
        query: { url: encodeURIComponent(to.fullPath) },
        replace: true,
      })
    })
}

export const pmd: RouteConfig[] = [
  {
    path: '/app/guidelines',
    name: 'marketplace_guidelines',
    component: EmptyRouterParent,
    children: [
      {
        path: 'app-rating-review',
        name: 'marketplace_guidelines_app_rating',
        component: AppReviewGuidelines,
        meta: {
          hideSideBar: false,
          hideTopBar: false,
        },
      },
    ],
  },
  {
    path: '/download/mobile_app',
    name: 'mobile_app_links',
    component: LaunchpadMobileAppLink,
  },
  {
    path: '/onboarding/success-call',
    name: 'onboarding-success-call',
    component: OnboardingImplementationCall,
    meta: {
      verificationRoute: true,
    },
  },
  {
    path: '/onboarding/kickoff-call',
    name: 'onboarding-trial-call',
    component: OnboardingKickoffCall,
    meta: {
      verificationRoute: true,
    },
  },
  {
    path: '/onboarding/v1',
    name: onboardingRoutes.onboardingFlow.version_a,
    component: OnboardingFlowV1,
    meta: {
      verificationRoute: true,
    },
    beforeEnter: requireAuth,
  },
  {
    path: '/forgot_password',
    name: 'forgot_password',
    component: ForgotPassword,
    meta: {
      translations: [Modules.Login],
    },
  },
  {
    path: '/change_password',
    name: 'change_password',
    component: ChangePassword,
    meta: {
      translations: [Modules.Login],
    },
  },
  {
    path: '/set_password',
    name: 'set_password',
    component: SetPassword,
    meta: {
      translations: [Modules.Login],
    },
  },
  {
    path: '/gdpr',
    name: 'gdpr_compliance',
    component: GdprCompliance,
    beforeEnter: requireAuth,
  },
  {
    path: '/agency_launchpad',
    name: agencyLaunchpadRoutes.default,
    component: AgencyLaunchpad,
    beforeEnter: requireAuth,
  },
  {
    path: '',
    name: 'login',
    component: LoginWithEmail,
    beforeEnter: (to, from, next) => {
      if (to.query.logout === 'true') return next()
      store
        .dispatch('auth/get')
        .then(() => {
          next({ name: 'dashboard', replace: true })
        })
        .catch(() => {
          next()
        })
    },
    meta: {
      translations: [Modules.Login],
    },
  },
  {
    path: '/preview-reports/:snapshot_token',
    name: 'preview-report-token',
    component: CustomReportSnapshotContainer,
  },
  {
    path: '/preview-reports',
    name: 'preview-report',
    component: CustomReportSnapshotContainer,
  },
  {
    path: '/login/sso',
    name: 'login_sso',
    component: LoginWithSSO,
    meta: {
      translations: [Modules.Login],
    },
  },
  {
    path: '/login/token',
    name: 'login_page',
    component: LoginWithToken,
    meta: {
      translations: [Modules.Login],
    },
  },
  {
    path: '/login/desktop',
    name: 'login_desktop',
    component: () => import('@/pmd/pages/LoginForDesktop.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/desktop/launch',
    name: 'desktop_launch',
    component: () => import('@/pmd/pages/DesktopLaunch.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/login/support',
    name: 'login_support',
    component: LoginForSupportAgent,
    beforeEnter: async (to, from, next) => {
      try {
        // Clear Firebase auth and app state before mounting the component
        await Promise.allSettled([firebase.auth().signOut(), store.dispatch('logoutSupportAgent')])
      } catch (err) {
        console.error('Error clearing auth state for support agent login:', err)
      }
      next()
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },
  {
    path: '/login/shopify',
    name: 'shopify_login',
    component: LoginWithShopify,
    beforeEnter: (to, from, next) => {
      if (to.query.logout === 'true') return next()
      store
        .dispatch('auth/get')
        .then(() => {
          next({
            name: 'shopify_dashboard',
            replace: true,
            query: to.query,
          })
        })
        .catch(() => {
          next()
        })
    },
  },
  // {
  //   path: '/agency_dashboard_v2',
  //   name: 'agency_dashboard_v2',
  //   component: AgencyDashboardRoot,
  //   beforeEnter: requireAuth,
  //   children: [
  //     {
  //       path: '',
  //       name: 'agency-dashboard-main',
  //       component: AgencyDashboardMain,
  //     },
  //   ],
  //   // meta: {
  //   //     translations: [Modules.Agency]
  //   //     module: [Modules.Agency]
  //   //     },
  // },
  {
    path: '/shopify/dashboard',
    name: 'shopify_dashboard',
    component: ShopifyLocationSelect,
    beforeEnter: requireAuth,
  },
  {
    path: '/eject/login',
    name: 'eject-login',
    component: EjectLocation,
    beforeEnter: (to, from, next) => {
      const token = window.localStorage.getItem('eject-token')
      if (token) {
        const tokenExpiry = window.localStorage.getItem('ej-expiry')
        if (!tokenExpiry || (tokenExpiry && parseInt(tokenExpiry) < new Date().getTime())) {
          window.localStorage.removeItem('eject-token')

          return next()
        } else {
          return next({ path: '/eject/agency-setup', query: to.query, replace: true })
        }
      } else {
        return next()
      }
    },
  },
  {
    path: '/eject/agency-setup',
    name: 'eject-agency-setup',
    component: EjectLocation,
    beforeEnter: (to, from, next) => {
      const token = window.localStorage.getItem('eject-token')
      if (token) {
        const tokenExpiry = window.localStorage.getItem('ej-expiry')
        if (!tokenExpiry || (tokenExpiry && parseInt(tokenExpiry) < new Date().getTime())) {
          window.localStorage.removeItem('eject-token')
          return next({ name: 'eject-login', replace: true })
        } else {
          return next()
        }
      } else {
        return next({ name: 'eject-login', replace: true })
      }
    },
  },
  {
    path: '/new-agency-97',
    name: 'signup',
    component: SignUp,
    beforeEnter: (to, from, next) => {
      store
        .dispatch('auth/get')
        .then(() => {
          next({ name: 'dashboard', replace: true })
        })
        .catch(() => {
          next()
        })
    },
  },
  {
    path: '/funnels/share/:share_id',
    name: 'share_funnel',
    component: AcceptShareFunnel,
    beforeEnter: requireShareAcceptAccess,
  },
  {
    path: '/template/share/:share_id',
    name: 'share_template',
    component: AcceptShareTemplate,
    beforeEnter: requireShareAcceptAccess,
  },
  {
    path: '/emails/share/:share_id',
    name: 'share_email_template_default',
    component: EmptyRouterParent,
    children: [
      {
        path: '',
        name: 'share_email_template',
        component: ImportEmailTemplate,
        beforeEnter: requireShareAcceptAccess,
        meta: {
          hideSideBar: false,
          hideTopBar: false,
        },
      },
    ],
  },
  {
    path: '/membership/products/share/:share_id',
    name: 'share_membership_product',
    component: AcceptShareMembershipProduct,
    beforeEnter: requireShareAcceptAccess,
  },
  {
    path: '/location/:location_id/workflow/:workflow_id*',
    component: workflowBuilder,
    name: 'editWorkflow',
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id?',
    component: LocationParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: '',
        name: 'dashboard_default',
        component: LocationDashboard,
        alias: '/location/:location_id',
      },
      {
        path: 'user-update',
        name: 'location_user_update',
        component: LocationUserUpdateMicroApp,
        meta: {
          hideSideBar: true,
          hideTopBar: true,
        },
      },
      {
        path: 'reporting/appointments-reports',
        name: 'appointments-reports',
        component: AppointmentsReportPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'call_stats',
        name: 'call_stats',
        component: CallReportingDashboard,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'agent_reporting',
        name: 'agent_reporting',
        component: AgentReporting,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: LocationDashboard,
      },
      {
        path: 'launchpad',
        name: 'location_launchpad',
        component: LaunchpadMicroApp,
      },
      {
        path: 'scheduling/appointments',
        name: 'appointments',
        component: AppointmentsPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'scheduling/appointments/reports',
        redirect: {
          name: 'appointments-reports',
        },
      },
      // {
      // 	path: 'scheduling/calendar',
      // 	name: 'calendar',
      // 	component: CalendarPage,
      // },
      {
        path: 'scheduling/calendar',
        name: 'calendar-v2',
        component: CalendarV2Page,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'reminders',
        name: 'reminders',
        component: RemindersPage,
      },
      {
        path: 'opportunities',
        name: 'opportunities',
        component: OpportunitiesPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'analysis',
        name: 'analysis',
        component: AnalysisPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'customers',
        name: 'customers_contact',
        component: EmptyRouterParent,
        children: [
          {
            path: 'bulk',
            component: CustomerImportsPage,
            children: [
              {
                path: 'actions',
                name: 'bulk_actions_log',
                component: BulkActionsView,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'bulk',
            name: 'customer_bulk_actions',
            component: CustomerImportsPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'bulkactions',
            name: 'bulk_actions',
            component: BulkActionsView,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'manual_actions',
            name: 'manual_actions',
            component: ManualActionList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'smart_list/:smart_list',
            name: 'smart_list',
            component: SmartList,
            beforeEnter: requireAuthAndLocation,
            meta: { translations: [Modules.SmartList, Modules.ContactDetail, Modules.BulkActions] },
          },
          {
            path: 'import_filter/:import_filter',
            name: 'import_filter',
            component: SmartList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'business_name/:business_name',
            name: 'business_name',
            component: SmartList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'detail/:contact_id',
            name: 'contact_detail',
            component: CustomerDetailNew,
            meta: {
              translations: [Modules.ContactDetail, Modules.SmartList, Modules.Task, Modules.Business, Modules.BulkActions],
            },
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'restore',
            name: 'contact_restore',
            component: CustomerRestore,
            beforeEnter: requireAuthAndLocation,
            meta: {
              translations: [Modules.SmartList, Modules.RestoreContacts, Modules.BulkActions, Modules.ContactDetail],
            },
          },
        ],
      },
      {
        path: 'membership',
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'dashboard',
            name: 'membership',
            component: membershipBuilder,
          },
          {
            path: 'product_blueprints',
            name: 'membership-product-blueprints',
            component: membershipBuilder,
          },
          {
            path: 'products',
            name: 'membership-products',
            component: membershipBuilder,
            children: [
              {
                path: 'library-order',
                name: 'membership-library-order',
                component: membershipBuilder,
              },
              {
                path: '*',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'offers',
            name: 'membership-offers',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'analytics',
            name: 'membership-analytics',
            component: membershipBuilder,
            children: [
              {
                path: 'product-progress',
                name: 'product-progress',
                component: membershipBuilder,
                children: [
                  {
                    path: '*',
                    component: membershipBuilder,
                  },
                ],
              },
            ],
          },
          {
            path: 'settings',
            name: 'membership-settings',
            component: membershipBuilder,
            children: [
              {
                path: 'site-details',
                name: 'membership-site-details',
                component: membershipBuilder,
              },
              {
                path: 'custom-domain',
                name: 'membership-custom-domain',
                component: membershipBuilder,
              },
              {
                path: 'email-settings',
                name: 'membership-email-settings',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'categories',
            name: 'membership-categories',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'posts',
            name: 'membership-posts',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'themes',
            name: 'membership-themes',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'themes-v2',
            name: 'membership-themes-new',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                name: 'membership-edit-themes-new',
                component: membershipBuilder,
              },
            ],
          },
        ],
      },
      {
        path: 'wordpress',
        name: 'wordpress',
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'wordpress/dashboard',
        name: 'wordpress_dashboard',
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/funnels/:funnel_id',
        name: 'funnels_detail',
        component: FunnelDetailPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'steps/:step_id?',
            name: 'funnel_steps',
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'overview',
                name: 'funnel_step_overview',
              },
              {
                path: 'publish',
                name: 'funnel_step_publish',
              },
              {
                path: 'product',
                name: 'funnel_step_product',
              },
              {
                path: 'products',
                name: 'funnel_step_products',
              },
              {
                path: 'products/create',
                name: 'funnel_step_product_v2',
              },
              {
                path: 'products/:funnel_product_id',
                name: 'funnel_step_product_v2_edit',
              },
            ],
          },
          {
            path: 'sales',
            name: 'funnel_sales',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'settings',
            name: 'funnel_settings',
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'funnels-websites/websites/:funnel_id',
        name: 'websites_detail',
        component: FunnelDetailPage,
        children: [
          {
            path: 'pages/:step_id?',
            name: 'website_pages',
          },
          {
            path: 'sales',
            name: 'website_sales',
          },
          {
            path: 'settings',
            name: 'website_settings',
          },
          {
            path: 'products/:step_id',
            name: 'website_products',
          },
          {
            path: 'website-products/:step_id',
            name: 'website_step_products',
          },
          {
            path: 'products/create/:step_id?',
            name: 'website_step_product_v2',
          },
          {
            path: 'products/:funnel_product_id',
            name: 'website_step_product_v2_edit',
          },
        ],
      },
      {
        path: 'funnels-websites/webinars/:funnel_id',
        name: 'webinars_detail',
        component: FunnelDetailPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'pages/:step_id?',
            name: 'webinar_pages',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'sales',
            name: 'webinar_sales',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'settings',
            name: 'webinar_settings',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'products/:step_id',
            name: 'webinar_products',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'webinar-products/:step_id',
            name: 'webinar_step_products',
          },
          {
            path: 'products/create',
            name: 'webinar_step_product_v2',
          },
          {
            path: 'products/:funnel_product_id',
            name: 'webinar_step_product_v2_edit',
          },
        ],
      },
      {
        path: 'funnels-websites/stores/:funnel_id',
        name: 'stores_detail',
        component: FunnelDetailPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'pages/:step_id?',
            name: 'stores_pages',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'sales',
            name: 'stores_sales',
            beforeEnter: requireAuthAndLocation,
          },

          {
            path: 'product-select',
            name: 'stores_product_select',
            beforeEnter: requireAuthAndLocation,
          },

          {
            path: 'settings',
            name: 'stores_settings',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'products/:step_id',
            name: 'stores_products',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'store-products/:step_id',
            name: 'store_step_products',
          },
          {
            path: 'products/create',
            name: 'store_step_product_v2',
          },
          {
            path: 'products/:funnel_product_id',
            name: 'store_step_product_v2_edit',
          },
        ],
      },
      {
        path: 'triggers',
        name: 'triggers',
        component: TriggersPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'new-workflow',
        component: workflowBuilder,
        name: 'newWorkflow',
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'workflow/create-workflow',
        name: 'createWorkflowByTemplate',
        component: workflowBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'workflows',
        name: 'workflows',
        component: workflowBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'overview',
        name: 'overview',
        component: workflowBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'triggers/:trigger_id',
        name: 'triggers_detail',
        component: TriggerDetailPage,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Task, Modules.SmartList] },
      },
      {
        path: 'analytics',
        name: 'analytics',
        component: Analytics,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'marketing',
        component: EmptyRouterParent,
        children: [
          {
            path: 'acquisition',
            name: 'customer_acquisition',
            component: CampaignList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaign/:campaign_id',
            name: 'campaign_edit',
            component: CampaignNew,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaign/:campaign_id/detail',
            name: 'campaign_detail',
            component: CampaignDetail,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaign/:campaign_id/list',
            name: 'campaign_accounts_list',
            component: CampaignAccountsList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'activity',
            name: 'campaign_activity',
            component: CampaignActivity,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'bulk',
            name: 'bulk_requests',
            component: BulkCampaignsPage,
            beforeEnter: requireAuthAndLocation,
          },

          // {
          // 	path: 'workflows',
          // 	name: 'workflows',
          // 	component: WorkflowList,
          // },
          // {
          // 	path: 'workflow/:workflow_id?',
          // 	name: 'workflow_edit',
          // 	component: WorkflowNew,
          // },
          {
            path: 'links',
            name: 'links',
            component: LinksPage,
            beforeEnter: requireAuthAndLocation,
            meta: { translations: [Modules.TriggerLinkAnalyze] },
          },
          {
            path: 'quiz-builder',
            name: 'quiz_builder',
            redirect: () => {
              return { name: 'quiz_builder_main' }
            },
            component: FormBuilderPage,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'main',
                name: 'quiz_builder_main',
                component: FormBuilderPage,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'submissions',
                name: 'quiz_builder_submissions',
                component: FormBuilderPage,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'form-builder',
            name: 'form_builder',
            redirect: () => {
              return { name: 'form_builder_main' }
            },
            component: FormBuilderPage,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'main',
                name: 'form_builder_main',
                component: FormBuilderPage,
                beforeEnter: requireAuthAndLocation,
                meta: { translations: [Modules.CustomField] },
              },
              {
                path: 'analyze',
                name: 'form_builder_analyze',
                component: FormBuilderPage,
                beforeEnter: requireAuthAndLocation,
                meta: { translations: [Modules.CustomField] },
              },
              {
                path: 'submissions',
                name: 'form_builder_submissions',
                component: FormBuilderPage,
                beforeEnter: requireAuthAndLocation,
                meta: { translations: [Modules.CustomField] },
              },
            ],
          },
          // old builder
          {
            path: 'emails/:path',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: '',
                name: 'emails_home-templates',
                component: Emails,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: '',
                name: 'emails_home-campaigns',
                component: Emails,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: '',
                name: 'emails_home-settings',
                component: Emails,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: '',
                name: 'emails_home-campaign-statistics',
                component: Emails,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'emails/detail/:path',
            name: 'emails_home_detail',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'form/:builder_id?/integrate',
            name: 'form_builder_integrate',
            component: EmbedBuilder,
            beforeEnter: requireAuthAndLocation,
            meta: { translations: [Modules.CustomField] },
          },
          {
            path: 'survey-builder',
            redirect: () => {
              return { name: 'survey_builder_main' }
            },
            name: 'survey_builder',
            component: SurveyList,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'main',
                name: 'survey_builder_main',
                component: SurveyList,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'analyze',
                name: 'survey_builder_analyze',
                component: SurveyList,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'submissions',
                name: 'survey_builder_submissions',
                component: SurveyList,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'survey/:survey_id?/integrate',
            name: 'survey_integrate',
            component: EmbedSurvey,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'text-templates',
            name: 'text_templates',
            component: TextBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'jotform/:builder_id',
            name: 'jotbox_form',
            component: JotboxForm,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'jotformsurvey/:survey_id',
            name: 'jotbox_survey',
            component: JotboxSurvey,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'media-storage',
        name: 'media-settings',
        component: MediaSettings,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'settings',
        component: SettingsPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '',
            name: 'settings',
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'audit/logs',
            name: 'audit-location',
            component: AuditLogs,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'profile',
            name: 'profile',
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'company',
            name: 'company_settings',
            component: CompanySettingsPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'billing',
            beforeEnter: requireAuthAndLocation,
            component: LocationBillingPage,
            children: [
              {
                path: '',
                name: 'location_billing',
                component: LocationBillingSettings,
              },
              {
                path: 'transactions',
                name: 'location_wallet_transactions',
                component: LocationWalletTransactions,
              },
            ],
          },
          {
            path: 'noshow_sms',
            name: 'no_show_sms_settings',
            component: NoShowSMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'birthday_sms',
            name: 'birthday_sms_settings',
            component: BirthdaySMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'integrations',
            name: 'integrations_settings',
            component: IntegrationSettingsPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'pipeline',
            name: 'pipeline_settings',
            component: PipelineSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'chat_widget',
            name: 'chat_widget',
            component: ChatWidgetSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'appointment_widget',
            name: 'appointment_widget',
            component: AppointmentWidgetSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'phone_number',
            name: 'phone_number',
            component: AllPhoneNumbersSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'templates',
            name: 'template_settings',
            component: TemplateSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'team',
            name: 'location_team_management',
            component: Team,
            beforeEnter: _requireAccessLevelAndLocation,
          },
          {
            path: 'teams',
            name: 'location_teams_management',
            component: AccountTeamsManagement,
            beforeEnter: _requireAccessLevelAndLocation,
          },
          {
            path: 'custom_fields',
            name: 'custom_fields_settings',
            component: AccountCustomFieldsSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { translations: [Modules.CustomField] },
          },
          {
            path: 'custom_values',
            name: 'custom_values_settings',
            component: CustomValues,
            beforeEnter: requireAuthAndLocation,
          },
          // {
          //   path: 'bulk_email_settings',
          //   name: 'bulk_email_settings',
          //   component: BulkEmailSettings,
          //   beforeEnter: requireAuthAndLocation
          // },
          {
            path: 'loc_mail_gun_settings',
            name: 'loc_mail_gun_settings',
            component: LocationMailGunSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'facebook',
            name: 'facebook_settings',
            component: FacebookAdFieldsMappingSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'domain',
            name: 'domain_settings',
            component: DomainSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'redirect',
            name: 'redirect_settings',
            component: RedirectSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'labs',
            name: 'labs_settings',
            component: GhlLabs,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'tags',
            name: 'tags_settings',
            component: TagsSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'custom_emails_settings',
            name: 'custom_emails_settings',
            component: CustomEmailsSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'smtp_service',
            name: 'smtp_service',
            component: SMTPServiceSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'eliza_faq',
            name: 'eliza_faq',
            component: ElizaFAQSetting,
            beforeEnter: async (to, from, next) => {
              const location = await Location.getById(to.params.location_id)
              store
                .dispatch('auth/get')
                .then(() => {
                  if (location && !location.botService)
                    next({
                      name: 'dashboard',
                      replace: true,
                      params: { location_id: to.params.location_id },
                    })
                  next()
                })
                .catch(() => {
                  next()
                })
            },
          },

          /*{
            path: 'attribution',
            name: 'attribution',
            component: AttributionSettings,
            beforeEnter: requireAuthAndLocation
          }*/
        ],
      },
      {
        path: 'logs',
        name: 'log-viewer',
        component: LogsPage,
        beforeEnter: requireAuthAndLocation,
        props: route => ({
          status: route.query.status,
        }),
      },
      {
        path: 'logs/:request_id',
        name: 'log-viewer-detail',
        component: LogViewer,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'notifications/:notification_id?',
        name: 'notifications',
        component: NotificationsPage,
      },
      {
        path: 'notificationslist',
        name: 'notificationslist',
        component: NotificationsList,
      },
      {
        path: 'custom-menu-link/:id',
        name: 'location_custom_menu_link',
        component: CustomMenuLinkPage,
      },
      {
        path: 'custom-page-link/:id',
        name: 'location_custom_page_link',
        component: CustomPagesLinkPage,
      },
    ],
  },
  {
    path: '/location/:location_id',
    component: EmptyLocationParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'google_location_select',
        name: 'google_location_select',
        component: GoogleLocationSelect,
      },
      {
        path: 'dr_chrono_office_select',
        name: 'dr_chrono_office_select',
        component: DrChronoOfficeSelect,
      },
      {
        beforeEnter: requireAuth,
        path: 'tiktok_account_select',
        name: 'tiktok_account_select',
        component: TikTokOauth,
      },
      {
        path: 'linkedin_page_select',
        name: 'linkedin_page_select',
        component: LinkedInAdAccountsPage,
      },
      {
        path: 'facebook_page_select-v2',
        name: 'facebook_page_select-v2',
        component: FacebookPageSelectV2,
      },
      {
        path: 'facebook_troubleshoot',
        name: 'facebook_troubleshoot',
        component: FacebookTroubleshoot,
      },
      {
        path: 'gmb_page_select',
        name: 'gmb_page_select',
        component: GMBPages,
      },
    ],
  },
  {
    path: '/support',
    name: 'support',
    component: SupportDashboard,
    beforeEnter: requireAuth,
    meta: { translations: [Modules.Agency] },
  },
  {
    path: '/holiday-promos',
    name: 'holiday-promos',
    component: offersPage,
    beforeEnter: requireAuth,
    meta: { translations: [Modules.Agency] },
  },
  {
    path: '/offers/:offerSource',
    name: 'offers',
    component: offersPage,
    beforeEnter: requireAuth,
    meta: { translations: [Modules.Agency] },
  },
  {
    beforeEnter: requireAuth,
    path: '/tiktok/oauth',
    name: 'tiktok-oauth',
    component: TikTokOauth,
  },
  {
    path: '/transfer-locations',
    name: 'location-transfer-page',
    component: locationTransferPage,
    beforeEnter: requireAuthAndScope('internaltools.location-transfer.write'),
    meta: { translations: [Modules.Agency] },
    children: [
      {
        path: 'bulk-transfer',
        name: 'bulk-transfer-page',
        component: locationTransferPage,
      },
      {
        path: 'bulk-eject',
        name: 'bulk-eject-page',
        component: locationTransferPage,
      },
    ],
  },
  // {
  //   path: '/bfcm2022',
  //   name: 'black_friday',
  //   component: BlackFriday,
  //   beforeEnter: requireAuth,
  // },
  // {
  //   path: '/annual_promo',
  //   name: 'annual-promotion',
  //   component: YearEndAnnualPromotion,
  //   beforeEnter: requireAuth,
  // },
  {
    path: '/lsa/manage-booking',
    name: 'lsa-manage-booking',
    component: LsaBusinessManager,
    beforeEnter: requireAuth,
  },
  {
    path: '/location/:location_id/emails/create/:template_id/:path',
    name: 'email_edit',
    component: EmailBuilderMicroApp,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id/page-builder/:page_id',
    name: 'page-builder-edit',
    component: FunnelBuilderApp,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id/blog-builder/:page_id',
    name: 'blog-builder-edit',
    component: FunnelBuilderApp,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id/page-builder/:page_id/versions',
    name: 'page-builder-edit_versions',
    component: FunnelBuilderApp,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/v2/location/:location_id/form-builder-v2/:builder_id',
    name: 'form-builder-manage-v2',
    component: FormBuilderApp,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.CustomField] },
  },
  {
    path: '/v2/location/:location_id/survey-builder-v2/:builder_id',
    name: 'survey-builder-manage-v2',
    component: surveyBuilderApp,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.CustomField] },
  },
  {
    path: '/v2/location/:location_id/quiz-builder-v2/:builder_id',
    name: 'quiz-builder-manage-v2',
    component: quizBuilderApp,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.CustomField] },
  },
  {
    path: '/location/:location_id/page-builder/:page_id/versions',
    name: 'page-builder-edit_versions',
    component: FunnelBuilderApp,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id/blog-builder/:page_id/versions',
    name: 'blog-builder-edit_versions',
    component: FunnelBuilderApp,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id/emails/campaigns/create',
    name: 'email_create_campaign',
    component: Emails,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: ':campaign_id',
        component: Emails,
        name: 'email_edit_campaign',
      },
      {
        path: ':campaign_id/schedule',
        component: Emails,
        name: 'email_schedule_campaign',
      },
      {
        path: ':campaign_id/preview',
        component: Emails,
        name: 'email_preview_campaign',
      },
      {
        path: ':campaign_id/versions',
        component: Emails,
        name: 'email_campaign_versions',
      },
    ],
  },
  {
    path: '/location/:location_id/medias',
    name: 'medias',
    component: MediaFilesPage,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/resources',
    name: 'agency_resources',
    component: AccountResources,
    beforeEnter: requireAuth,
  },

  {
    path: '/help',
    name: 'help',
    component: HelpDocuments,
    beforeEnter: requireAuth,
  },
  {
    path: '/custom-menu-link/:id',
    name: 'custom_menu_link',
    component: CustomMenuLinkPage,
  },
  {
    path: '/custom-page-link/:id',
    name: 'custom_page_link',
    component: CustomPagesLinkPage,
  },
  {
    path: '/inactive',
    name: 'inactive',
    component: InactiveAgency,
    beforeEnter: requireAuth,
  },
  {
    path: '/suspended',
    name: 'suspended-agency',
    component: SuspendedAgency,
    beforeEnter: requireAuth,
  },
  {
    path: '/inactive-renewal',
    name: 'sandbox-inactive',
    component: SandboxInactiveAgency,
    beforeEnter: requireAuth,
  },
  {
    path: '/locked',
    name: 'inactive_location',
    component: InactiveLocation,
    beforeEnter: requireAuth,
  },
  {
    path: '/v2/location/:location_id/memberships/certificates/:certificate_id/edit',
    name: 'edit-certificates',
    component: certificatesBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/v2/location/:location_id/memberships/certificates/badges/:badge_id/edit',
    name: 'edit-badges',
    component: certificatesBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id/countdown-timer/create/:id?',
    name: 'countdown_timer_builder_create',
    component: CountdownTimerBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: '/location/:location_id/countdown-timer/:id?',
    name: 'countdown_timer_builder_edit',
    component: CountdownTimerBuilder,
    beforeEnter: requireAuthAndLocation,
  },
  /**
   * Jobber Integration Redirect Route
   *
   * This route handles redirects for users coming from Jobber integration.
   *
   * Behavior:
   * 1. If user has an active session:
   *    - Agency users: Redirect to /integration/67dab149c081668666dc5f1e
   *    - Location users: Redirect to /v2/location/{locationId}/integration/67dab149c081668666dc5f1e
   *      (uses the first location the user has access to)
   *
   * 2. If no session exists:
   *    - Sets a 'source=jobber' cookie (30-day expiry)
   *    - Redirects to https://www.gohighlevel.com/jobber
   */
  {
    path: '/jobber-redirect',
    name: 'jobber_redirect',
    beforeEnter: async (to: Route, from: Route, next: (to?: RawLocation) => void) => {
      try {
        // Check if user session exists
        const user = new User(await store.dispatch('user/get'))

        if (!user.companyId) {
          throw new Error('User not found')
        }

        // Get the Jobber integration ID
        const jobberIntegrationId = '67dab149c081668666dc5f1e'

        // Check if user is agency level or location level
        if (user.type === User.TYPE_AGENCY) {
          // Agency level user - redirect to agency integration page
          next({
            path: `/integration/${jobberIntegrationId}`,
            replace: true,
          })
        } else if (user.type === User.TYPE_ACCOUNT) {
          // Location level user - get first location they have access to
          const availableLocations = keys(user.locations) || []
          const firstLocationId = first(availableLocations)

          if (firstLocationId) {
            // Redirect to location-specific integration page
            next({
              path: `/v2/location/${firstLocationId}/integration/${jobberIntegrationId}`,
              replace: true,
            })
          } else {
            // No locations available, redirect to dashboard
            next({
              name: 'dashboard',
              replace: true,
            })
          }
        } else {
          // Unknown user type, redirect to dashboard
          next({
            name: 'dashboard',
            replace: true,
          })
        }
      } catch (error) {
        // Session doesn't exist or error occurred
        setJobberLeadSourceAndRedirect()
      }
    },
  },
  // {
  //   path: '*',
  //   redirect: '/'
  // }
]
